import React, { useEffect } from 'react';
import { navigate } from 'gatsby';

const Calculator = () => {
  useEffect(() => {
    const handler = (event) => {
      const data = JSON.parse(event.data);
      if (data.message === 'SuccessFully submitted') {
        window.removeEventListener('message', handler);
        navigate('/thank-you/');
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('message', handler);
    }

    // clean up
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('message', handler);
      }
    };
  }, []);
  return (
    <div className="hero is-fullheight">
      <iframe
        className="hero is-fullheight"
        title="capextax"
        src="https://capex-calculator.vercel.app/"
        width="100%"
        frameBorder="0"
        height="100%"
      />
    </div>
  );
};

export default Calculator;
